import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import NotificationContent from "./NotificationContent";
import { notificationService } from '../../service/firebase/notificationService';
import type { Notification } from '../../type';

const NotificationPage = () => {
  const queryClient = useQueryClient();

  // 알림 목록 조회
  const { data: notifications = [], isLoading, error } = useQuery({
    queryKey: ['notifications'],
    queryFn: () => notificationService.getAll(),
  });

  // 알림 추가
  const addNotificationMutation = useMutation({
    mutationFn: (notification: Notification) => notificationService.create(notification),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });

  // 알림 삭제
  const deleteNotificationMutation = useMutation({
    mutationFn: (notificationId: string) => notificationService.delete(notificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });

  const handleAddNotification = async (notification: Notification) => {
    await addNotificationMutation.mutateAsync(notification);
  };

  const handleDeleteNotification = async (notificationId: string) => {
    await deleteNotificationMutation.mutateAsync(notificationId);
  };

  return (
    <NotificationContent 
      notifications={notifications}
      loading={isLoading}
      error={error?.message || null}
      addNotification={handleAddNotification}
      deleteNotification={handleDeleteNotification}
    />
  );
};

export default NotificationPage;